import React, { useEffect, useState } from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import { CircularProgress } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import useCommonApi from "../../api/useCommonApi";

export interface IAutocomplete {
    id: number | string
    nombre: string
    descripcion?: string
    parentId: number | string
}

export interface IClienteSku extends IAutocomplete {
    alto: number;
    largo: number;
    ancho: number;
    peso: number;
    embalajeId: number | string;
    clienteSkuId: number | string;
    item: string;
}

interface IAutocompleteProps {
    name: string
    source: string
    label: string
    placeholder?: string
    value: IAutocomplete | null
    defaultValue?: IAutocomplete | null
    filter?: any
    variant?:any,
    minLength?: number,
    width?: string | number,
    onChange: <T>(event, optionSelected: T) => void
}

const AutocompleteControl = ({
    value,
    source,
    label,
    onChange,
    placeholder,
    filter,
    variant,
    minLength = 1,
    width = '100%'
}: IAutocompleteProps) => {

    const [searchText, setSearchText] = useState('');
    const [options, setOptions] = React.useState<IAutocomplete[]>([]);
    const [loading, setLoading] = useState(false);
    const apiSource = useCommonApi();

    useEffect(() => {

        let text = ''
        if (value?.parentId) {
            text = value?.parentId.toString()
        } else if (value?.id) {
            text = value?.id.toString()
        }

        setSearchText(text)
    }, [value]);

    useEffect(() => {
        const timer = setTimeout(triggerChange, 1000);

        return () => {
            clearTimeout(timer);
        };
    }, [searchText]);

    const triggerChange = () => {

         if (searchText && searchText.length >= minLength) {
            setLoading(true);
            (async () => {
                const data = { Texto: searchText, ...filter };
                const result = await apiSource.obtenerAsync<IAutocomplete[]>(source, data);

                setOptions(result);
                setLoading(false);
            })();
        } else
            setOptions([]);
    };

    const textChange = (event) => {
        setSearchText(event.target.value)
    };

    const handleChange = (event, optionSelected) => {
        if (!optionSelected) setOptions([]);
         if (event != null) {
             onChange(event, optionSelected)
         }
    };

    return (
         <Box style={{ width: width || '100%' }}>
            <Autocomplete
                options={options}
                getOptionSelected={(option, value) => option.id === value.id}
                getOptionLabel={option => option.nombre ?  option.nombre : ''}
                filterOptions={(options) => options}
                renderOption={(option) => (
                    <>
                        <Box display="flex" flexDirection="column" fontSize={14}>
                            <Box fontWeight="fontWeightMedium">
                                {option.nombre}
                            </Box>
                            <Box fontWeight="fontWeightLight" fontSize={10}>
                                {option.descripcion}
                            </Box>
                        </Box>
                    </>
                )}
                onChange={handleChange}
                value={value}

                loading={loading}
                renderInput={params => (
                    <TextField
                        {...params}
                        onChange={textChange}
                        variant={variant == null ? "filled" :variant}
                        label={label}
                        placeholder={placeholder || ""}
                        fullWidth
                        InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                                <React.Fragment>
                                    {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                    {params.InputProps.endAdornment}
                                </React.Fragment>
                            ),
                        }}
                    />
                )}
            />
         </Box>
    );
};

export default AutocompleteControl;
